<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    import { afterUpdate } from 'svelte';

    import StatusIcon from './StatusIcon.svelte';
    import Emoji from '../../_wrappers/Emoji.svelte';

    import type { FormInputBinding } from '$lib/types/Components/SharedTypes';

    export let placeholder = '';
    export let showEmoji = false;
    export let emoji = '';
    export let required = false;
    export let invalid = false;
    export let pristine = true;
    export let touched = false;
    export let active = false;
    export let finalFormInput: FormInputBinding = {
        name: '',
        value: '',
        onChange: () => {},
        onBlur: () => {},
        onFocus: () => {},
    };
    export let errorMessage = '';
    export let focusColor = '';
    export let outlineColor = '';

    let showError = invalid && touched;
    let showSuccess = !invalid && touched && !pristine;
    let textareaContainerClasses: string;
    let textareaClasses: string;

    afterUpdate(() => {
        showError = invalid && touched;
        showSuccess = !invalid && touched && !pristine;
    });

    const borderRadius = getBorderRadius('fieldsWrapper');

    $: textareaContainerClasses = cn(
        'fun-box-border fun-size-full fun-border fun-bg-white fun-p-4 fun-align-middle fun-ring-2 fun-ring-transparent fun-transition-all',
        borderRadius,
        {
            ['fun-pl-12']: showEmoji,
            ['fun-border-[var(--focusColor)] fun-ring-[var(--outlineColor)]']: active,
        },
    );

    $: textareaClasses = cn(
        'fun-size-full fun-resize-none fun-appearance-none fun-bg-transparent fun-align-middle fun-font-ui fun-text-base fun-font-light fun-text-black fun-placeholder-gray-500 fun-outline-none fun-transition',
        {
            'fun-pr-24': !required && pristine,
        },
    );
</script>

<div class="fun-relative fun-box-border fun-flex fun-h-32 fun-items-center sm:fun-h-40">
    {#if showEmoji}
        <u
            class="fun-absolute fun-left-4 fun-top-5 fun-flex fun-h-5 fun-select-none fun-items-center fun-no-underline"
            aria-hidden="true"
        >
            <Emoji {emoji} size="20px" />
        </u>
    {/if}

    {#if !required && !invalid && pristine}
        <u
            class="fun-absolute fun-right-6 fun-top-5 fun-text-xs fun-font-light fun-text-gray-500 fun-no-underline"
        >
            (optional)
        </u>
    {/if}

    <StatusIcon {showError} {showSuccess} showCheckmark={false} />

    <div
        class={textareaContainerClasses}
        style="--outlineColor: {outlineColor}; --focusColor: {focusColor}"
    >
        <textarea
            class={textareaClasses}
            {placeholder}
            name={finalFormInput.name}
            aria-label={placeholder}
            on:blur={finalFormInput.onBlur}
            on:focus={finalFormInput.onFocus}
            on:input={(e) => finalFormInput.onChange(e.currentTarget.value)}
            >{finalFormInput.value ? finalFormInput.value : ''}</textarea
        >

        {#if errorMessage && showError}
            <div
                class="fun-absolute fun-bottom-4 fun-text-xs fun-font-normal fun-leading-tight fun-text-red-600"
            >
                {errorMessage}
            </div>
        {/if}
    </div>
</div>
